//client/src/pages/admin/AdminMassOrderUpload.js
import { useState } from "react";
import api from "../../api/axiosInstance";
import { toast } from "react-hot-toast";

export default function AdminMassOrderUpload() {
  const [file, setFile] = useState(null);

  const submit = async () => {
    if (!file) return toast.error("CSV file required");

    const form = new FormData();
    form.append("file", file);

    await api.post("/admin/mass-orders/csv", form);
    toast.success("Mass orders uploaded");
    setFile(null);
  };

  return (
    <div className="space-y-6 max-w-xl">
      <h1 className="text-2xl font-bold">Mass Order Upload</h1>

      <input
        type="file"
        accept=".csv"
        onChange={(e) => setFile(e.target.files[0])}
        className="input-glass"
      />

      <button onClick={submit} className="btn-primary w-full">
        Upload CSV
      </button>

      <div className="card-glass p-4 text-sm text-gray-300 space-y-2">
        <h3 className="font-semibold text-white">Mass Order Instructions</h3>
        <ol className="list-decimal ml-5 space-y-1">
          <li>Create a CSV with columns: <b>service_id, link, quantity</b></li>
          <li>Each row = one order</li>
          <li>Quantity must be within service min & max</li>
          <li>Save as <b>.csv</b></li>
          <li>Upload above</li>
        </ol>
        <p className="text-yellow-400">
          ⚠ Invalid rows are skipped automatically
        </p>
      </div>
    </div>
  );
}

